const systemRouter = {  
  path: 'yis',
  name: 'yis',
  component: () => import('@/views/test/yis.vue')
}

export default systemRouter